import { render } from "./Panel.vue?vue&type=template&id=2e134ee7&scoped=true"
import script from "./Panel.vue?vue&type=script&lang=js"
export * from "./Panel.vue?vue&type=script&lang=js"

import "./Panel.vue?vue&type=style&index=0&id=2e134ee7&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src740499781/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e134ee7"]])

export default __exports__